export default "__VITE_ASSET__BYov$35m__"